// 公式执行
export const zkFun = {
    // null or undefined 转化成 0
    ToZero: (val: any) => {
        console.log('ToZero: ',val)
        if (['(null)','(undefined)', null, undefined].includes(val)) return 0;
        return val;
    },
    // null or undefined 转化成 '--'
    Tobar: (val: any) => {
        if (['(null)','(undefined)', null, undefined].includes(val)) return '--';
        return val;
    }
};

// 公式配置
export const funNameList = [
    { name: '空转0', value: 'zkFun.ToZero(' },
    { name: '空转-', value: 'zkFun.Tobar(' }
];
